import React from "react";

import { observer } from "mobx-react";
import { Bet } from "@models";
import FiskalySection from "@components/fiscalization/mobile/FiskalySection";

import {
	DeviceSerialNumber,
	TransactionNumber,
	TransactionSignature,
	TransactionSignatureCounter,
	TransactionTimestamp,
} from "./fiscalization-components";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

export const BetDetailsModalFiscalization = observer(
	function BetDetailsModalFiscalization(props: {
		bet: Bet;
		isActive: boolean;
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
	}) {
		const { bet } = props;

		if (!bet.metadata) {
			return null;
		}

		if (props.isActive && "fiskalyReceiptNumber" in bet.metadata) {
			return (
				<FiskalySection
					metadata={bet.metadata}
					currency={bet.currency}
				/>
			);
		}

		if (
			bet.metadata?.fiscalizationItems == null ||
			bet.metadata.fiscalizationItems.length < 0
		) {
			return null;
		}

		const firstFinishedTransaction = bet.metadata.fiscalizationItems.find(
			(i: any) => i.isFinishTransaction == true
		);

		if (!firstFinishedTransaction) {
			return null;
		}

		if (!props.isActive) {
			return null;
		}

		return (
			<div className="table--bet__details table--bet__fiscalization">
				<TransactionTimestamp
					firstFinishedTransaction={firstFinishedTransaction}
					isStart
				/>
				<TransactionTimestamp
					firstFinishedTransaction={firstFinishedTransaction}
				/>
				<TransactionNumber
					firstFinishedTransaction={firstFinishedTransaction}
				/>
				<TransactionSignatureCounter
					firstFinishedTransaction={firstFinishedTransaction}
				/>
				<DeviceSerialNumber
					deviceSerialNumber={bet.metadata.deviceSerialNumber}
				/>
				<TransactionSignature
					firstFinishedTransaction={firstFinishedTransaction}
				/>
			</div>
		);
	}
);

export type FiscalizationMetaData = {
	dateCreated: Date;
	deviceSerialNumber: string;
	externalId: string;
	fiscalizationItems: FiscalizationItem[];
	processType: number;
	referenceId: string;
	status: number;
};

export type FiscalizationItem = {
	isFinishTransaction: boolean;
	signature: string;
	signatureCounter: number;
	status: number;
	transactionNumber: number;
	transactionTimestamp: string;
};
